import { z } from 'zod';

export const SIGN_UP_FORM_SCHEMA = z.object({
  name: z
    .string()
    .min(1, { message: 'Full name is required.' })
    .regex(/^[a-zA-Z]+(?: [a-zA-Z]+)+$/, {
      message: 'Please enter your full name (first and last)'
    }),
  email: z.string().email({ message: 'Invalid email address.' }),
  password: z
    .string()
    .min(8, { message: 'Password must be at least 8 characters long.' })
    .regex(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/, {
      message:
        'Password must contain at least one uppercase letter, one number, and one special character.'
    })
});

export const SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SELF_SERVE_SIGNUP_SITE_KEY;
